export default {"src":"https://search.testwiggot.com/_next/static/media/thunderbolt.e12c969b.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};